import { FormDefault, FormDefaultType } from "@/services/bedrock";

/** Every type Manage Defaults sets, in its column order, with the names its columns use. */
export const ACCOUNT_DEFAULT_TYPES: { type: FormDefaultType; label: string }[] = [
  { type: "review", label: "Review" },
  { type: "midpoint", label: "Mid-transaction check-in" },
  { type: "bad_review_feedback", label: "Bad Review Feedback" },
];

/**
 * The types with no account-level default. That default is the fallback for players whose region or
 * branch has none and for links with no player, so a missing one leaves them with no form to open.
 */
export function missingAccountDefaults(defaults: Pick<FormDefault, "formType" | "segmentationDetailId">[]) {
  return ACCOUNT_DEFAULT_TYPES.filter(
    ({ type }) => !defaults.some(d => d.formType === type && (d.segmentationDetailId ?? null) === null)
  );
}

/** "Review", "Review and Mid-transaction check-in", "Review, Mid-transaction check-in and Bad Review Feedback". */
export function joinLabels(labels: string[]) {
  if (labels.length <= 1) return labels.join("");
  return `${labels.slice(0, -1).join(", ")} and ${labels[labels.length - 1]}`;
}
